var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2C9 1.17157 8.32843 0.5 7.5 0.5C6.67157 0.5 6 1.17157 6 2H5C5 0.619288 6.11929 -0.5 7.5 -0.5C8.88071 -0.5 10 0.619288 10 2H14.5C14.7761 2 15 2.22386 15 2.5C15 2.77614 14.7761 3 14.5 3H13.946L12.6499 14.2292C12.5335 15.2384 11.679 16 10.6631 16H4.33688C3.321 16 2.4665 15.2384 2.35006 14.2292L1.053 3H0.5C0.25454 3 0.0503916 2.82312 0.00805569 2.58988L0 2.5C0 2.22386 0.223858 2 0.5 2H9ZM12.938 3H2.061L3.34347 14.1146C3.40169 14.6192 3.82894 15 4.33688 15H10.6631C11.1711 15 11.5983 14.6192 11.6565 14.1146L12.938 3ZM6 5.5C6.24546 5.5 6.44961 5.65477 6.49194 5.85886L6.5 5.9375V12.0625C6.5 12.3041 6.27614 12.5 6 12.5C5.75454 12.5 5.55039 12.3452 5.50806 12.1411L5.5 12.0625V5.9375C5.5 5.69588 5.72386 5.5 6 5.5ZM9 5.5C9.24546 5.5 9.44961 5.65477 9.49194 5.85886L9.5 5.9375V12.0625C9.5 12.3041 9.27614 12.5 9 12.5C8.75454 12.5 8.55039 12.3452 8.50806 12.1411L8.5 12.0625V5.9375C8.5 5.69588 8.72386 5.5 9 5.5Z",
    fill: "#D73A49"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedDeleteIcon);
export default __webpack_public_path__ + "static/media/red-delete-icon.038449ea77329f6ad0959a2ad90ce2ce.svg";
export { ForwardRef as ReactComponent };